(function(){
    jQuery.expr.filters.offscreen = function(el) {
        var rect = el.getBoundingClientRect();
        return (
                 (rect.left + rect.width) < 0 
                   || (rect.top + rect.height) < 0
                   || (rect.left + rect.width > window.innerWidth || rect.top + rect.height > window.innerHeight)
               );
      };
})();